import angular from 'angular';
import helloPackModal from './helloPackModal';
import './style.scss';

export default angular
  .module('helloPack.scenes.helloPackModal', [])
  .component('helloPackModal', helloPackModal).name;
